import { environment } from "./../../../../environments/environment";
import { JobsService } from "./../../main/accountant/jobs-and-tasks/jobs.service";
import { Subject } from "rxjs";
import { DomSanitizer } from "@angular/platform-browser";
import { HotToastService } from "@ngneat/hot-toast";
import { DashboardService } from "./../../dashboard.service";
import {
  Component,
  PACKAGE_ROOT_URL,
  OnInit,
  OnChanges,
  SimpleChanges,
  ViewChild,
  AfterViewInit,
  ChangeDetectorRef,
  Input,
  ChangeDetectionStrategy,
  Output,
  EventEmitter,
  OnDestroy,
} from "@angular/core";
import { Location, NgIf, NgFor, NgClass } from "@angular/common";
import { BsModalService } from "ngx-bootstrap/modal";
import { BsModalRef } from "ngx-bootstrap/modal";
import { AccountantService } from "../../main/accountant/accountant.service";
import {
  UntypedFormBuilder,
  UntypedFormGroup,
  UntypedFormControl,
  Validators,
  FormsModule,
  ReactiveFormsModule,
} from "@angular/forms";
import { FormUtil } from "../../../utils/formutils";
import { ConversationsService } from "../conversations.service";

import { FileUploadModalComponent } from "../../main/accountant/modals/file-upload-modal.component";
import { MoveFileModalComponent } from "../../main/accountant/modals/move-file-modal.component";
import { FilesManagerService } from "../../files-manager/files-manager.service";
import { LocalStorageService } from "src/app/utils/localstorage.service";
import { BsDropdownModule } from "ngx-bootstrap/dropdown";
import { InitialsDirective } from "../../../utils/initials.directive";
import { TypeaheadModule } from "ngx-bootstrap/typeahead";
import { UploadProgressBarComponent } from "../../../utils/upload-progress-bar/upload-progress-bar.component";
import { Editor, EditorModule } from "primeng/editor";
import Quill from "quill";
import { DropdownModule } from "primeng/dropdown";
import { User, Data as UserData } from "../../shared-data.service";

/* This is a component which we pass in modal*/
@Component({
  selector: "new-tracked-item-modal",
  templateUrl: "./new-tracked-item-modal.component.html",
  styleUrls: ["./new-tracked-item-modal.component.scss"],
  imports: [
    NgIf,
    FormsModule,
    DropdownModule,
    NgFor,
    UploadProgressBarComponent,
    ReactiveFormsModule,
    TypeaheadModule,
    NgClass,
    InitialsDirective,
    BsDropdownModule,
    EditorModule,
  ],
})
export class NewTrackedItemModalComponent implements OnInit, AfterViewInit {
  formUtil: FormUtil;
  accountants: UserData[] = [];
  tracked_items = [
    {
      message: "",
      type: "5",
      focused: true,
      answer: 0,
      uuid: this.generateUUID(),
      files: [],
    },
  ];
  isBatch: boolean = false;
  conversations = [];

  editMode = false;

  editTemplateMode = false;

  selectedFolderToUploadName = null;

  clientsToNotify: any[];

  conversation_id: any;
  tracked_item = {
    message: "",
    type: "5",
    focused: true,
    answer: 0,
    uuid: "",
    files: [],
  };
  user: any;
  template_name = "";
  templates = [];
  template_edited_uuid: any = null;
  disableSend = false;
  autoRemind = false;
  fileRemoved = false;
  autoRemindDays: any = 2;
  public inlineMode: object = { enable: true, onSelection: true };
  selectedTemplate = null;
  showProgressBar: boolean = false;
  progressPercentage: number = 0;

  @ViewChild("templateList", { static: true }) templateList: any;
  @ViewChild("rte") public rte: Editor;

  @ViewChild("pEditor")
  public editor: Editor;

  @Input() isDraft: boolean;

  windowLoaded = false;

  @Input() isJobDraft: boolean;

  public serializedTrackedItems: Subject<any>;

  public iframe: object = { enable: true };

  bsFileUploadModalRef: BsModalRef;
  selectedFiles = [];

  fileForm: FormData = new FormData();

  @Output() messageEvent = new EventEmitter<any>();

  constructor(
    public bsModalRef: BsModalRef,
    private accountantService: AccountantService,
    private formBuilder: UntypedFormBuilder,
    private localStorage: LocalStorageService,
    public toastr: HotToastService,
    private conversationsService: ConversationsService,
    private dashboardService: DashboardService,
    private cdr: ChangeDetectorRef,
    public sanitizer: DomSanitizer,
    public jobsService: JobsService,
    private modalService: BsModalService,
    private filesManagerService: FilesManagerService,
    private location: Location,
  ) {}

  templatesCtrl = new UntypedFormControl();

  templatesForm = new UntypedFormGroup({
    templates: this.templatesCtrl,
  });
  loadingAccountants: boolean;
  currentUser: User;
  sendFrom: UserData;

  ngOnDestroy(): void {}

  ngOnInit(): void {
    this.currentUser = this.localStorage.get("user");

    if (this.isDraft || (this.editMode && this.tracked_items[0]["is_draft"])) {
      this.loadingAccountants = true;
      this.accountantService.get_company_info().then((info) => {
        this.loadingAccountants = false;
        this.accountants = info.accountants;
        this.sendFrom = this.accountants.find(
          (p) =>
            p?.user?.id ===
            (this.tracked_items[0]["created_by"]?.id ?? this.currentUser.id),
        );
      });
    }

    this.serializedTrackedItems = new Subject();
    this.toggleFocus(this.tracked_items[this.tracked_items.length - 1]);
    this.handleAndGetConversationUsers();

    if (this.tracked_item["initial_reminder_date"] != null) {
      this.autoRemind = true;
    }

    this.checkAutoRemind();

    this.conversationsService.get_tracked_items_template().then(
      (res: any) => {
        this.templates = res.tracked_item_templates;
        this.cdr.detectChanges();
      },
      (err) => {},
    );

    this.cdr.detectChanges();

    setTimeout(() => {
      this.windowLoaded = true;
    }, 500);

    this.selectedFolderToUploadName =
      this.checkDisplayForFolderSelectionOnInit();
  }

  ngAfterViewInit(): void {
    setTimeout(() => {
      this.cdr.detectChanges();

      if (this.editor.getQuill() != null) {
        // const FontAttributor: any = Quill.import("attributors/class/font");
        // FontAttributor.whitelist = ["roboto"];
        // Quill.register(FontAttributor, true);

        this.editor.getQuill().focus();
      }
      this.cdr.detectChanges();
    }, 100);
  }

  async handleAndGetConversationUsers() {
    let conversationId;
    if (this.editMode) {
      conversationId = this.tracked_item["conversation"];
    } else {
      if (!this.isJobDraft) {
        conversationId = this.conversation_id;
      } else {
        conversationId = await this.getConversationIdByCompanyId();
      }
    }

    if (conversationId != null) {
      this.conversationsService
        .get_conversation_users(conversationId)
        .then((res: any[]) => {
          const [tracked_item] = this.tracked_items;
          if (this.editMode || tracked_item["is_draft"]) {
            const usersToNotify = tracked_item["clients_to_notify"].map(
              (user) => user.id,
            );

            if (Array.isArray(res)) {
              this.clientsToNotify = res.map((user) => ({
                ...user,
                selected: usersToNotify.includes(user.id) ? true : false,
              }));
            }
          } else {
            if (res.length > 0) {
              this.clientsToNotify = res.map((user) => ({
                ...user,
                selected: true,
              }));
            }
          }
        });
    }
  }

  async getConversationIdByCompanyId() {
    if (this.conversation_id == null) return;
    const { conversation: conversationId } =
      await this.conversationsService.get_conversation_by_company_id(
        this.conversation_id,
        true,
      );

    return conversationId;
  }

  generateUUID() {
    var d = new Date().getTime();
    var d2 =
      (typeof performance !== "undefined" &&
        performance.now &&
        performance.now() * 1000) ||
      0;
    return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(
      /[xy]/g,
      function (c) {
        var r = Math.random() * 16;
        if (d > 0) {
          r = (d + r) % 16 | 0;
          d = Math.floor(d / 16);
        } else {
          r = (d2 + r) % 16 | 0;
          d2 = Math.floor(d2 / 16);
        }
        return (c === "x" ? r : (r & 0x3) | 0x8).toString(16);
      },
    );
  }

  addTrackedItem(): void {
    this.tracked_items.push({
      message: "",
      uuid: this.generateUUID(),
      type: "5",
      focused: true,
      answer: 0,
      files: [],
    });
    this.toggleFocus(this.tracked_items[this.tracked_items.length - 1]);
    this.tracked_item.type = "5";

    this.cdr.detectChanges();
  }

  toggleFocus(t_item): void {
    this.tracked_items.forEach((item) => {
      item.focused = false;
    });

    t_item.focused = true;
    this.tracked_item = t_item;
    this.tracked_item.type = this.tracked_item.type.toString();

    if (this.editor != null) {
      this.editor.getQuill().focus();
    }

    this.cdr.detectChanges();
  }

  createDrafts() {
    this.disableSend = true;

    for (let x = 0; x < this.tracked_items.length; x++) {
      for (let y = 0; y < this.tracked_items[x].files.length; y++) {
        if (this.tracked_items[x].files[y]["id"] == null) {
          this.fileForm.append(
            `files_${this.tracked_items[x].files[y].tracked_item}`,
            this.tracked_items[x].files[y],
            this.tracked_items[x].files[y].name,
          );
        }
      }
    }

    this.tracked_items.forEach((item) => {
      item["conversation_id"] = this.conversation_id;
    });

    if (this.clientsToNotify != null) {
      const clientsToNotifyId = this.clientsToNotify
        .filter((client) => client.selected)
        .map((client) => client.id);

      this.fileForm.append(
        "clients_to_notify",
        JSON.stringify(clientsToNotifyId),
      );
    }

    this.fileForm.append("tracked_items", JSON.stringify(this.tracked_items));
    this.fileForm.append("isJobDraft", "true");
    this.fileForm.append("sendFrom", this.sendFrom.user.id.toString());

    if (this.autoRemind == true) {
      this.fileForm.append("remind_in", this.autoRemindDays.toString());
    }

    this.conversationsService.createDraftsV2FormData(this.fileForm).then(
      (res: any) => {
        const response = res;
        this.serializedTrackedItems.next(response);

        this.bsModalRef.hide();

        this.disableSend = false;
      },
      (err) => {
        console.log(err);
      },
    );
  }

  createTrackedItems(): void {
    this.disableSend = true;

    for (let x = 0; x < this.tracked_items.length; x++) {
      for (let y = 0; y < this.tracked_items[x].files?.length; y++) {
        if (this.tracked_items[x].files[y]["id"] == null) {
          this.fileForm.append(
            `files_${this.tracked_items[x].files[y].tracked_item}`,
            this.tracked_items[x].files[y],
            this.tracked_items[x].files[y].name,
          );
        }
      }
    }

    this.tracked_items.forEach((item) => {
      item["conversation_id"] = this.conversation_id;
    });

    this.fileForm.append("tracked_items", JSON.stringify(this.tracked_items));
    this.fileForm.append(
      "remind_in",
      this.autoRemind ? this.autoRemindDays.toString() : null,
    );

    if (this.editMode) {
      this.patchCreateTrackedItems();
    } else {
      if (this.isBatch) {
        this.postCreateBatchTrackedItems();
      } else {
        this.postCreateTrackedItems();
      }
    }
  }

  private patchCreateTrackedItems() {
    if (!this.editTemplateMode) {
      const clientsToNotifyId = this.clientsToNotify
        .filter((client) => client.selected)
        .map((client) => client.id);

      this.fileForm.append(
        "clients_to_notify",
        JSON.stringify(clientsToNotifyId),
      );
    }

    if (this.sendFrom) {
      this.fileForm.append("sendFrom", this.sendFrom.user.id.toString());
    }

    if (this.autoRemind == false || this.autoRemind == null) {
      this.tracked_item["initital_reminder_date"] = null;
    }
    const templateUuid = this.template_edited_uuid;
    if (templateUuid != null) {
      this.fileForm.append("template_uuid", templateUuid);
      // location.reload(); // Temporary fix to SECOND CREATED initial client task not showing text
    }

    this.conversationsService.editTrackedItemV2FormData(this.fileForm).then(
      (res: any) => {
        if (this.editTemplateMode) {
          res.tracked_items.forEach(
            ({ uuid, task_name, initial_reminder_date, clients_to_notify }) => {
              const matchingTrackedItem = this.tracked_items.find(
                (item) => item.uuid === uuid,
              );
              if (matchingTrackedItem) {
                matchingTrackedItem["task_name"] = task_name;
                matchingTrackedItem["initial_reminder_date"] =
                  initial_reminder_date;
              }
            },
          );
        } else {
          this.tracked_item["created_by"] = res.tracked_items[0].created_by;
          // this line only adds the task_name to the tracked_item because it has to be added without html tags
          this.tracked_item["task_name"] = res.task_name[0];
          this.tracked_item["clients_to_notify"] =
            res.tracked_items[0].clients_to_notify;
          this.tracked_item["initial_reminder_date"] =
            res.tracked_items[0].initial_reminder_date;
          if (this.tracked_item.type == "2") {
            this.tracked_item["selected_folder_to_receive_files"] =
              res.tracked_items[0].selected_folder_to_receive_files;
          }
        }

        this.cdr.detectChanges();
        this.conversationsService.updateTrackedItem$.next(this.tracked_item);
        this.bsModalRef.hide();
        this.disableSend = false;
      },
      (err) => {
        console.log(err);
      },
    );
  }

  private postCreateTrackedItems() {
    this.disableSend = true;

    if (this.clientsToNotify != null) {
      const clientsToNotifyId = this.clientsToNotify
        .filter((client) => client.selected)
        .map((client) => client.id);

      this.fileForm.append(
        "clients_to_notify",
        JSON.stringify(clientsToNotifyId),
      );
    }

    this.conversationsService
      .newAddTrackedItemsV2FormData(this.fileForm)
      .subscribe(
        (res: any) => {
          if (
            this.tracked_items.some(
              (tracked_item) => tracked_item.files.length > 0,
            )
          ) {
            this.showProgressBar = true;
            if (res?.status === "progress") {
              let serverPercentage = res?.message;
              this.progressPercentage = serverPercentage;
              this.cdr.detectChanges();

              if (this.progressPercentage === 100) {
                this.showProgressBar = false;
                this.cdr.detectChanges();
              }
            } else if (res?.status === "completed") {
              this.cdr.detectChanges();
              this.progressPercentage = 0;

              if (res != null) {
                if (res.response != null) {
                  this.conversationsService.newPlaceholderTrackedItems.next(
                    res.response.tracked_items,
                  );
                }

                this.cdr.detectChanges();
              }

              this.bsModalRef.hide();

              this.selectedFolderToUploadName = "";
            }
          } else {
            if (res != null) {
              if (res.response != null) {
                this.conversationsService.newPlaceholderTrackedItems.next(
                  res.response.tracked_items,
                );
              }

              this.cdr.detectChanges();
            }

            this.bsModalRef.hide();
            this.selectedFolderToUploadName = "";
          }
        },
        (error: any) => {
          console.log(error);
        },
      );
  }

  private postCreateBatchTrackedItems() {
    let batchTrackedItems = [];

    this.fileForm.append(
      "conversation_ids",
      JSON.stringify(this.conversations),
    );
    this.conversationsService
      .addBatchTrackedItemsV2FormData(this.fileForm)
      .then(
        (res: any) => {
          const response = res;
          this.bsModalRef.hide();
          this.disableSend = false;
        },
        (err) => {
          console.log(err);
        },
      );
  }

  focusTemplateInput() {
    this.templateList.focus();
  }

  removeTrackedItem(index): void {
    if (this.tracked_items.length == 1) {
      this.toastr.error("You need to have at least one initial client task");
      return;
    }
    this.tracked_items.splice(index, 1);
  }

  newTrackedItemTemplate() {
    this.dashboardService.show_loading.next(true);

    for (let x = 0; x < this.tracked_items.length; x++) {
      for (let y = 0; y < this.tracked_items[x].files.length; y++) {
        this.fileForm.append(
          `files_${this.tracked_items[x].files[y].tracked_item}`,
          this.tracked_items[x].files[y],
          this.tracked_items[x].files[y].name,
        );
      }
    }

    this.fileForm.append("tracked_items", JSON.stringify(this.tracked_items));
    this.fileForm.append("name", this.template_name);

    this.conversationsService
      .addTrackedItemsTemplateV2FormData(this.fileForm)
      .then(
        (res: any) => {
          this.dashboardService.show_loading.next(false);
          this.toastr.success(res.message);
        },
        (err) => {
          this.dashboardService.show_loading.next(false);
          this.toastr.error(err.error.message);
        },
      );
  }

  async typeaheadOnSelect(event) {
    let res = await this.conversationsService.get_tracked_items_template_detail(
      event.item.uuid,
    );

    if (this.tracked_items.length == 1 && this.tracked_items[0].message == "") {
      this.tracked_items = res.tracked_items;
      this.tracked_items[0].focused = true;
      this.tracked_item = this.tracked_items[0];
    } else {
      res.tracked_items.forEach((t) => {
        this.tracked_items.push(t);
      });
    }

    this.toggleFocus(this.tracked_items[this.tracked_items.length - 1]);

    this.cdr.detectChanges();
  }

  identify(index, item) {
    return item.uuid;
  }

  detect() {
    this.cdr.detectChanges();
  }

  getFileExt(filename) {
    if (filename !== undefined && filename !== null) {
      return filename.split(".")[1];
    } else {
      return null;
    }
  }

  debug() {
    console.log(this.tracked_item);
  }

  public openModalFileUpload() {
    this.bsFileUploadModalRef = this.modalService.show(
      FileUploadModalComponent,
      {
        initialState: {
          currentConversationID: this.conversation_id,
          formdataOnly: true,
        },
      },
    );

    this.bsFileUploadModalRef.content.onUpload.subscribe((files) => {
      if (this.tracked_item.files === undefined) {
        this.tracked_item.files = [];
      }
      this.tracked_item.files = this.tracked_item.files.concat(files);

      this.tracked_item.files.forEach((file) => {
        if (file["id"] == null) {
          let url = URL.createObjectURL(file);
          file["filename"] = file.name;
          file["url"] = url;
          file["ext"] = this.getFileExt(file.name);
          file["tracked_item"] = this.tracked_item.uuid;
        }
      });

      this.cdr.detectChanges();
    });
  }

  removeFile(i: number) {
    this.tracked_item.files.splice(i, 1);
  }

  checkAutoRemind() {
    if (this.tracked_item["initial_reminder_date"] != null) {
      const reminderDate = new Date(this.tracked_item["initial_reminder_date"]);
      const calculatedDays = Math.round(
        Math.floor(reminderDate.getTime() - new Date().getTime()) /
          (1000 * 60 * 60 * 24),
      );
      this.autoRemindDays =
        calculatedDays < 0 ? "0" : calculatedDays.toString();
    }
  }

  async openModalFolderUpload() {
    let conversationId: number;

    if (this.editMode) {
      conversationId = this.tracked_items[0]["conversation"];
    } else if (this.isDraft && this.isJobDraft) {
      if (this.conversation_id != null) {
        const { conversation: id } =
          await this.conversationsService.get_conversation_by_company_id(
            this.conversation_id,
            true,
          );
        conversationId = id;
      }
    } else {
      conversationId = this.conversation_id;
    }

    const initialState = {
      currentConversationID: conversationId,
      receiveFilesFromClientTask: true,
    };
    const moveFolderModal = this.modalService.show(MoveFileModalComponent, {
      initialState,
      keyboard: false,
    });
    moveFolderModal.content.onClose.subscribe(
      async ({ target_uuid, selectedWorkspace }) => {
        if (!target_uuid) {
          moveFolderModal.hide();
          return;
        }
        const { title: folderName, uuid }: { title: string; uuid: string } =
          await this.filesManagerService.getFolder(conversationId, target_uuid);

        this.selectedFolderToUploadName = folderName;
        this.cdr.detectChanges();

        this.fileForm.append("selected_folder_uuid", uuid);
        moveFolderModal.hide();
      },
    );
  }

  checkDisplayForFolderSelectionOnInit(): string {
    let display: string;
    if (this.editMode) {
      this.tracked_item["selected_folder_to_receive_files"]?.name
        ? (display =
            this.tracked_item["selected_folder_to_receive_files"]?.name)
        : (display = "Select Folder");
    } else {
      this.selectedFolderToUploadName
        ? (display = this.selectedFolderToUploadName)
        : (display = "Select Folder");
    }

    return display;
  }
}
